import {
  ListItemButton,
  ListItem,
  ListItemText,
  Typography,
  ListItemAvatar,
  Avatar,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ItemOperatore = ({ operatore }: { operatore: any }) => {

  const navigate = useNavigate();

  function stringAvatar(nomecognome: string) {
    return {
      children: nomecognome,
    };
  }

  return (
    <ListItemButton>
      <ListItem
        onClick={() => navigate("/operatore/" + operatore.idoperatorecantiere)}
        alignItems="flex-start"
        style={{ cursor: "pointer" }}
      >
        <ListItemText
          primary={operatore.nomecognome}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: "inline" }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                Ultima Marcata
              </Typography>
              {" — " + operatore.dataoraultimamarcata.substr(11,19)}
            </React.Fragment>
          }
        />
        <ListItemAvatar>
          <Avatar {...stringAvatar(operatore.nomecognome)} src={operatore.immagine_profilo} />
        </ListItemAvatar>
      </ListItem>
    </ListItemButton>
  );
};

export default ItemOperatore;
